module.exports = __webpack_public_path__ + "img/ry_logo.e401201a.png";